module.exports = __webpack_public_path__ + "img/banner1.36cead40.png";